function gridIndexToWorld(grid, ijk) {
    const world = [grid.origin[0], grid.origin[1], grid.origin[2]];
    for (let axis = 0; axis < 3; axis++) {
        const distance = ijk[axis] * grid.spacing[axis];
        world[0] += grid.direction[axis * 3] * distance;
        world[1] += grid.direction[axis * 3 + 1] * distance;
        world[2] += grid.direction[axis * 3 + 2] * distance;
    }
    return world;
}
function gridWorldToIndex(grid, world) {
    const dx = world[0] - grid.origin[0];
    const dy = world[1] - grid.origin[1];
    const dz = world[2] - grid.origin[2];
    const ijk = [0, 0, 0];
    for (let axis = 0; axis < 3; axis++) {
        const projection = dx * grid.direction[axis * 3] +
            dy * grid.direction[axis * 3 + 1] +
            dz * grid.direction[axis * 3 + 2];
        ijk[axis] = projection / grid.spacing[axis];
    }
    return ijk;
}
function mapIndexBetweenGrids(source, target, ijk) {
    return gridWorldToIndex(target, gridIndexToWorld(source, ijk));
}
function mapIndexToNearestVoxel(source, target, ijk) {
    const mapped = mapIndexBetweenGrids(source, target, ijk);
    return [Math.round(mapped[0]), Math.round(mapped[1]), Math.round(mapped[2])];
}
function gridContainsIndex(grid, ijk) {
    for (let axis = 0; axis < 3; axis++) {
        if (ijk[axis] < 0 || ijk[axis] > grid.dimensions[axis] - 1) {
            return false;
        }
    }
    return true;
}
function cornersOfBounds(bounds) {
    const corners = [];
    for (const i of bounds[0]) {
        for (const j of bounds[1]) {
            for (const k of bounds[2]) {
                corners.push([i, j, k]);
            }
        }
    }
    return corners;
}
function gridCoversRegion(source, bounds, target) {
    const tolerance = 0.5 + 1e-6;
    for (const corner of cornersOfBounds(bounds)) {
        const mapped = mapIndexBetweenGrids(source, target, corner);
        for (let axis = 0; axis < 3; axis++) {
            if (mapped[axis] < -tolerance ||
                mapped[axis] > target.dimensions[axis] - 1 + tolerance) {
                return false;
            }
        }
    }
    return true;
}
function mapBoundsBetweenGrids(source, target, bounds) {
    const tolerance = 1e-6;
    const faces = [
        [bounds[0][0] - 0.5, bounds[0][1] + 0.5],
        [bounds[1][0] - 0.5, bounds[1][1] + 0.5],
        [bounds[2][0] - 0.5, bounds[2][1] + 0.5],
    ];
    const mapped = [
        [Infinity, -Infinity],
        [Infinity, -Infinity],
        [Infinity, -Infinity],
    ];
    for (const corner of cornersOfBounds(faces)) {
        const point = mapIndexBetweenGrids(source, target, corner);
        for (let axis = 0; axis < 3; axis++) {
            mapped[axis][0] = Math.min(mapped[axis][0], point[axis]);
            mapped[axis][1] = Math.max(mapped[axis][1], point[axis]);
        }
    }
    return [
        [
            Math.ceil(mapped[0][0] - 0.5 + tolerance),
            Math.floor(mapped[0][1] + 0.5 - tolerance),
        ],
        [
            Math.ceil(mapped[1][0] - 0.5 + tolerance),
            Math.floor(mapped[1][1] + 0.5 - tolerance),
        ],
        [
            Math.ceil(mapped[2][0] - 0.5 + tolerance),
            Math.floor(mapped[2][1] + 0.5 - tolerance),
        ],
    ];
}
function boundsOfGrid(grid) {
    return [
        [0, grid.dimensions[0] - 1],
        [0, grid.dimensions[1] - 1],
        [0, grid.dimensions[2] - 1],
    ];
}
function boundsOfFrame(grid, frameIndex) {
    return [
        [0, grid.dimensions[0] - 1],
        [0, grid.dimensions[1] - 1],
        [frameIndex, frameIndex],
    ];
}
function intersectBounds(a, b) {
    return [
        [Math.max(a[0][0], b[0][0]), Math.min(a[0][1], b[0][1])],
        [Math.max(a[1][0], b[1][0]), Math.min(a[1][1], b[1][1])],
        [Math.max(a[2][0], b[2][0]), Math.min(a[2][1], b[2][1])],
    ];
}
function volumeOfBounds(bounds) {
    let volume = 1;
    for (let axis = 0; axis < 3; axis++) {
        const length = bounds[axis][1] - bounds[axis][0] + 1;
        if (length <= 0) {
            return 0;
        }
        volume *= length;
    }
    return volume;
}
function containsBounds(outer, inner) {
    for (let axis = 0; axis < 3; axis++) {
        if (inner[axis][0] < outer[axis][0] || inner[axis][1] > outer[axis][1]) {
            return false;
        }
    }
    return true;
}
function sameBounds(a, b) {
    for (let axis = 0; axis < 3; axis++) {
        if (a[axis][0] !== b[axis][0] || a[axis][1] !== b[axis][1]) {
            return false;
        }
    }
    return true;
}
export { gridIndexToWorld, gridWorldToIndex, mapBoundsBetweenGrids, boundsOfGrid, boundsOfFrame, intersectBounds, volumeOfBounds, sameBounds, containsBounds, mapIndexBetweenGrids, mapIndexToNearestVoxel, gridContainsIndex, gridCoversRegion, cornersOfBounds, };
